import React from 'react'

import DynamicPresentationCard from '../../../../containers/dynamic/DynamicPresentationCard'
import EditableReply from '../../../../containers/replies/EditableReply'

const Reply = ({ item }) => {
  return (
    <DynamicPresentationCard
      reply={item}
      noWrapper
      size="small"
      ValueWrapper={props => <EditableReply record={item} {...props} />}
    />
  )
}

export default Reply
